import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
  TypedUseSelectorHook,
} from "react-redux";

import { slices } from "./slices";

const rootReducer = combineReducers({
  tabSlice: slices.tabSlice.reducer,
  cartSlice: slices.cartSlice.reducer,
  filterSlice: slices.filterSlice.reducer,
  mytrade: slices.mytradeSlice.reducer,
  home: slices.homeSlice.reducer,
  profile: slices.profileSlice.reducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export const store = configureStore({ reducer: rootReducer });
export type AppDispatch = typeof store.dispatch;
export const { dispatch } = store;
export const useDispatch = () => useAppDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<AppState> = useAppSelector;
